import ApiService from "../../../ApiService";

const DetailsService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/loadscreenview", vo, successCallback, failureCallback);
    },
    loadUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/loadunits", vo, successCallback, failureCallback);
    },
    deleteSections: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/deletesections", vo, successCallback, failureCallback);
    },
    reorderSections: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/reordersections", vo, successCallback, failureCallback);
    },
    deleteUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/deleteunits", vo, successCallback, failureCallback);
    },
    reorderUnits: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/oralbook/details/reorderunits", vo, successCallback, failureCallback);
    },
};

export default DetailsService;